import styled from 'styled-components';

import colors from '../../../../../styles/colors';

// Boxed like the card fields (PaymentForm's ElementContainer), so it lines up with them.
const Container = styled.section`
  display: flex;
  flex-direction: column;
  gap: 6px;
  margin-top: 15px;
  padding: 10px 20px;
  max-width: 450px;
  border-radius: 5px;
  border: 1px solid ${colors.shades.gamma14};
  background-color: ${({ $isDarkTheme }) => ($isDarkTheme ? colors.shades.dark1 : colors.shades.secondary5)};
`;

const HeaderRow = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 8px;
`;

const Title = styled.span`
  display: flex;
  align-items: center;
  gap: 8px;
  font-size: 16px;
  font-weight: 600;
  color: ${({ $isDarkTheme }) => ($isDarkTheme ? colors.base.alpha : colors.base.beta)};
`;

const ActionButton = styled.button`
  min-height: 44px;
  padding: 0 4px;
  border: none;
  background: none;
  font-size: 14px;
  cursor: pointer;
  text-decoration: underline;
  color: ${({ $isDarkTheme }) => ($isDarkTheme ? colors.shades.gamma3 : colors.shades.gamma10)};
`;

const Details = styled.p`
  margin: 0;
  font-size: 14px;
  line-height: 1.5;
  color: ${colors.shades.gamma14};
`;

const OriginalPrice = styled.s`
  opacity: 0.7;
`;

export {
  Container,
  HeaderRow,
  Title,
  ActionButton,
  Details,
  OriginalPrice,
};
